import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { NavLink } from 'react-router-dom/cjs/react-router-dom.min';
import styled from 'styled-components';

import EyeClosedIcon from '../../../../assets/img/EyeClosedIcon';
import EyeDollarIcon from '../../../../assets/img/EyeDollarIcon';
import { USERS_ACTIONS } from '../../../store/actions/reducer-actions/users';
import { Colors } from '../../../styles/vars';
import { connect } from '../../../utils/redux';
import Paths from '../../routes/paths';
import Button from '../Button';
import Flex from '../containers/Flex';
import Input from '../Input';
import PageTitle from '../PageTitle';
import Popup from '../Popup';
import Separator from '../Separator';

const CatalogueMargin = styled.label`
  display: flex;
  justify-content: flex-start;
  align-items: baseline;
  gap: 8px;

  font-weight: 450;

  p {
    margin: 0;
  }
`;

const PriceModeSwitcher = ({
  isPriceHidden,
  setUserPriceHidden,
  setUserPriceMargin,
}) => {
  const [isPopupOpen, setPopupOpen] = useState(false);
  const [margin, setMargin] = useState(0);

  if (isPriceHidden) {
    return (
      <Button
        fromComponent={NavLink}
        to={Paths.Login()}
        color={Colors.black}
        background={Colors.pureWhite}
        hoverColor={Colors.black}
        hoverBackground={Colors.white}
      >
        <EyeClosedIcon />
        <span>Afficher les prix</span>
      </Button>
    );
  }

  return (
    <>
      <Button
        type="button"
        color={Colors.black}
        background={Colors.pureWhite}
        hoverColor={Colors.black}
        hoverBackground={Colors.white}
        onClick={() => setPopupOpen(true)}
      >
        <EyeDollarIcon />
        <span>Masquer les prix</span>
      </Button>

      <Popup
        open={isPopupOpen}
        backgroundColor={Colors.white}
        dismissible={false}
        cancelButton={({ onClick }) => (
          <Button hoverBackground={Colors.red} onClick={onClick}>
            <span>Annuler</span>
          </Button>
        )}
        confirmButton={({ onClick }) => (
          <Button
            color={Colors.white}
            background={Colors.accent}
            onClick={onClick}
          >
            <span>OK</span>
          </Button>
        )}
        onClose={event => {
          const { popupSuccess } = event.detail;

          if (popupSuccess) {
            // TODO: Handle in reducer
            setUserPriceMargin(margin);
            setUserPriceHidden(true);
          }

          setPopupOpen(false);
        }}
      >
        <Flex
          direction="column"
          align="flex-start"
          gap="20px"
          style={{ padding: '0 40px', color: Colors.black }}
        >
          <PageTitle margin="20px">Mode catalogue</PageTitle>

          <Flex direction="column" align="flex-start" gap="8px">
            <div>Les prix des produits seront masqués.</div>
            <div>
              Vous aurez besoin de vous identifier afin d’afficher les prix à
              nouveau.
            </div>
          </Flex>

          <Separator color={Colors.pureWhite} style={{ width: '100%' }} />

          <CatalogueMargin htmlFor="catalogue-margin">
            <p>Appliquer une marge de</p>

            <Input
              type="number"
              name="catalogue-margin"
              min={0}
              max={100}
              step={0.1}
              value={margin}
              onChange={value => setMargin(value)}
              style={{ width: '6em' }}
              square
            />

            <code>%</code>

            <p>aux prix du catalogue.</p>
          </CatalogueMargin>
        </Flex>
      </Popup>
    </>
  );
};

PriceModeSwitcher.propTypes = {
  isPriceHidden: PropTypes.bool,
  setUserPriceHidden: PropTypes.func.isRequired,
  setUserPriceMargin: PropTypes.func.isRequired,
};

PriceModeSwitcher.defaultProps = {
  isPriceHidden: false,
};

export default connect(
  state => ({ isPriceHidden: state.users?.currentUser?.isPriceHidden }),
  {
    setUserPriceHidden: USERS_ACTIONS.setUserPriceHidden,
    setUserPriceMargin: USERS_ACTIONS.setUserPriceMargin,
  },
)(PriceModeSwitcher);
